import React from "react";
import Cookies from "js-cookie";
function TextField(props) {
  const [value, setValue] = React.useState(null);
  const [link, setLink] = React.useState(null);
  React.useEffect(() => {
    if (props.value) {
      if(props.id==8){
        
        setValue(commafy(props.value.replace(/['"]+/g, "")));
      }
      else{
      setValue(props.value.replace(/['"]+/g, "").toLocaleString('en-IN'));
      }
    }
    if(props.id==281)
    {
      console.log(props)
      setLink("https://www.walkscore.com/");
      var parcel=props.data.find((item) => item.ParameterId === 291 ? ((item.Value=='No' ) ? 0 : item.Value) : 0);
      if(parcel!=null && parcel !=undefined){
      document.getElementById("siteinfo").href="https://blue.kingcounty.com/Assessor/eRealProperty/Dashboard.aspx?ParcelNbr="+parcel.value.replace(/['"]+/g, ""); 
      document.getElementById("geoana").href="https://web.seattle.gov/dpd/ParcelData/Parcel.aspx?pin="+parcel.value.replace(/['"]+/g, ""); 
      }
    }
    if(props.id==282)
    {
      setLink("https://howloud.com/soundscore/");
    }
    // else{
    //   setValue(0);
    // }
  }, []);

  function commafy( num ) 
  {
    var str = num.toString().split('.');
    if (str[0].length >= 5) {
        str[0] = str[0].replaceAll(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 5) {
        str[1] = str[1].replaceAll(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
}
  const onChange1 = (e) => {

    document.getElementById("PresentOther").style.display='none';
  
      document.getElementById("PresentUseID").style.display='inline-block';
    
  }
  const onChange = (e) => {

    document.getElementById('param'+props.id).removeAttribute('style');
    const value = e.target.value;

    if(props.id==283 || props.id==16){
      setValue(e.target.value);
      props.data.find((item) => item.ParameterId === props.id).Value=value;
      }
    else{
    if (!isNaN(value)) 
    {
      setValue(e.target.value);
      props.data.find((item) => item.ParameterId === props.id).Value=value;
      if(props.id==8){
        setValue(commafy(e.target.value.replace(/['"]+/g, "")));
      }
      console.log(props)
  
    // props.setData(
    //   props.data.map((item) => {
    //     if(item.ParameterId === props.id){

    //       return  { ...item, Value: value }
    //     }
    //     else return item;

    //   })
    // );
    }}
 
  };


if(props.id==283){
  return (
    <div class="form-group col-md-3" id="PresentOther" style={{display:"none"}}>
    
      <label >{props.name}</label>
      <input
        type="text"
        value={value}
        onChange={onChange}
        id={'param' + props.id}
       onDoubleClick={onChange1}
        //placeholder={props.name}
        class="form-control"
      
      />
    </div>


  );
}
if(props.id==8){
  return (
    <div class="form-group col-md-3" >
    
   
     <label >{props.name}</label>
     <div class="test">
      <input
        type="text"
        value={value}
        onChange={onChange}
        id={'param' + props.id}
       onDoubleClick={onChange1}
        //placeholder={props.name}
        class="form-control"
      
      />
    </div>
    </div>

  );
}
if(props.id==282 || props.id==281){
  return (
    <div class="form-group col-md-3" >
    
    <a  href={link} target="_blank"><img style={{width:"10%"}} src="/assets/img/outside-page-LB.svg"></img></a> 
     <label >{props.name}</label>
      <input
        type="text"
        value={value}
        onChange={onChange}
        id={'param' + props.id}
       onDoubleClick={onChange1}
        //placeholder={props.name}
        class="form-control"
      
      />
    </div>


  );
}
else{
    return (
      <div class="form-group col-md-3">
      
        <label >{props.name}</label>
        <input
          type="text"
          value={value}
          onChange={onChange}
          id={'param' + props.id}
         
          //placeholder={props.name}
          class="form-control"
          style={{WebkitAppearance: "none"}}
        />
      </div>


    );}
}


export default TextField;

